module.exports = __webpack_public_path__ + "media/v2/phone_main-9b7d2dc7.png";